import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { CompositeFilterDescriptor, State } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { TreeFilter } from '~/front-models/treeFilter';
import { treeFilterMapOptions } from '~/front-models/treeFilterMap';
import { whereFilterMapOptions } from '~/front-models/whereFilterMap';
import { AccountSite } from '~/models/AccountSite';
import { GridFieldSummary } from '~/models/modules/gridField';
import { Site } from '~/models/Site';
import { SecurityService } from '~/services/security.service';
import { SitesEnum } from '~/shared/enums/sites.enum';

import { MultiSiteService } from '~/services/modules/common/multi-site.service';

@Component({
    selector: 'account-site-popup',
    templateUrl: './account-site-popup.component.html',
    styleUrls: ['./account-site-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AccountSitePopupComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() resolver: (params?: any, model?: any) => Observable<any[]>;
  @Input() returnUrl: string;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('accountComboBox') accountComboBox: ComboBoxComponent;
  @ViewChild('comboboxSite') comboboxSite: ComboBoxComponent;

  filteringEnable: boolean;
  _searchQuery: string;
  _state: State = {
    skip: 0,
    take: 30,
    sort: [],
    group: [],
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  _customFieldInFilter: boolean;
  _gridColumns: GridFieldSummary[];
  _customFieldChanged: string;
  pagingEnabled: boolean = false;
  _searchEnabled: boolean = false;
  sortingEnabled: boolean = false;
  _deleted: boolean = false;
  returnedSelectedKeys: any[];
  _items: AccountSite[];
  _sites: Site[];
  selectedAccount: AccountSite;
  selectedSite: Site;
  _loggedInAccountSites: string = "";
  _ShowDailog: boolean = false;
  constructor(
    private _securityService: SecurityService,
    private _multiSitesService: MultiSiteService,
    private router: Router) {
  }

  ngAfterViewInit(): void {
    if (this.accountComboBox != undefined) {
      this.accountComboBox.toggle(true);
      this.accountComboBox.isFocused = true;
    }
  }

  ngOnDestroy() {
    this._items = undefined;
    this._sites = undefined;
    this.selectedAccount = undefined;
    this.selectedSite = undefined;
    this._loggedInAccountSites = "";
  }

  ngOnInit() {
    this.loadDefaultData();
  }

  private loadDefaultData() {
    const modelParam = this._getParamModel();
    const modelFilter = this.filteringEnable ? this._getFilterModel(true) : {};
    const model = {
      filter: modelFilter,
      selectedIds: this.returnedSelectedKeys
    };
    this.resolver(modelParam, model).pipe().subscribe((data: any) => {
      this._items = data.value ?? data.data.value;
      this.OnAccountOneSite();
    });
  }

  private _getParamModel(): any {
    const model = {
      page: this._state.skip / this._state.take + 1,
      pageSize: this._state.take,
      search: this._searchQuery,
      orderBy: this._state && this._state.sort[0] ? this._state.sort[0].field : '',
      orderByMethod: this._state && this._state.sort[0] ? this._state.sort[0].dir : '',
      deleted: this._deleted.toString(),
    };

    if (!model.orderByMethod) {
      delete model.orderBy;
    }
    else {
      // fix orderby if the field is an object
      const sortingField = model.orderBy.split('.');
      if (sortingField.length) {
        model.orderBy = sortingField[0];
      }
    }

    if (!this.pagingEnabled) delete model.page;
    if (!this.pagingEnabled) delete model.pageSize;
    if (!this._searchEnabled) delete model.search;
    if (!this.sortingEnabled) delete model.orderBy;
    if (!this.sortingEnabled) delete model.orderByMethod;

    return model;
  }

  private _getFilterModel(fromDefaultLoading?: boolean): any {
    const model: any = {
      where: {
        operatorType: treeFilterMapOptions['and'],
        operands: [],
      },
    };
    let isCustomField: boolean;
    this._customFieldInFilter = false;

    if (this._state.filter.filters.length) {
      this._state.filter.filters.forEach(
        (columnFilter: CompositeFilterDescriptor) => {
          // fill operation for each column
          let cloumnFilters: TreeFilter[] = [];
          isCustomField = false;
          columnFilter.filters.forEach((filter: any) => {
            // check if custom field
            if (this.isCustomField(filter.field.toString())) {
              isCustomField = true;
            }
            //
            cloumnFilters.push({
              field: isCustomField ? 'value' : filter.field.toString(),
              filterType: whereFilterMapOptions[filter.operator],
              value: filter.value,
            });
          });

          if (!isCustomField && fromDefaultLoading || isCustomField && !fromDefaultLoading) {
            model.where.operands.push({
              operatorType: treeFilterMapOptions[columnFilter.logic],
              operands: cloumnFilters,
            });
          }
        });
    }
    else {
      return {};
    }

    if (!model.where.operands.length) {
      return {};
    }

    return model;
  }

  private isCustomField(field: string) {
    if (this._gridColumns != null && this._gridColumns.find(x => x.isCustomField && x.field === field)) {
      this._customFieldChanged = field;
      return true;
    }
    else {
      return false;
    }
  }

  ChooseAccount(event: AccountSite) {
    if (this.accountComboBox != undefined) {
      this.accountComboBox.isFocused = false;
    }

    this.comboboxSite.toggle(true);
    this.comboboxSite.isFocused = true;
    this.comboboxSite.value = undefined;
    this.selectedSite = undefined;
    this._sites = [];

    if (event) {
      this._sites = event.sites;
    }
  }

  Continue() {
    var _selectedAccountsAndSitesArray: any[] = [];
    var _selectedAccountsAndSites: any = {
      siteId: this.selectedSite.id === 0 ? SitesEnum.AllSites : this.selectedSite.id,
      accountId: this.selectedAccount.id
    };

    _selectedAccountsAndSitesArray.push(_selectedAccountsAndSites);

    this._loggedInAccountSites = JSON.stringify(_selectedAccountsAndSitesArray);

    if (localStorage.getItem('accessToken') && localStorage.getItem('refreshToken')) {
      this._securityService.setCurrentUser().subscribe(() => {
        localStorage.setItem('loggedInAccountSites', this._loggedInAccountSites);
        this.router.navigate([this.returnUrl]);
      });
    }
  }

  Close() {
    this.onClose.emit(true);
  }

  OnAccountOneSite() {
    if (this._items.length == 0) {
      this.onClose.emit(true);
      this.router.navigate([this.returnUrl]);
    }

    if (this._items.length == 1) {
      this.selectedAccount = this._items[0];
      this._sites = [...this._items[0].sites];
      this.selectedSite = this._sites[0];
    }

    if (this._items.length == 1 && this._items[0].sites.length == 1) {
      this.selectedSite = this._items[0].sites[0];
      this.Continue();

    }
    else {
      this._ShowDailog = true;
    }
  }
}